
import { HttpUnsourcedInboundList,HttpExportUnsourcedInbound} from '@/service/inbound';
import TableList from "@components/templates/tablelist";

import comIndex from './update'
import { mapGetters } from 'vuex';
import mixin from './mixin';

export default {
    mixins: [TableList, mixin],
    components:{
        comIndex,
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                isManage: true,
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
        };
    },
    methods: {
        ajaxRequest: HttpUnsourcedInboundList,
        interceptRequest(params){
            // console.log(params)
            const {sku} = params.search;
           
            params.sku = sku;
            delete params.search.sku;
            return params
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case 'query':
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show:true,
                        width:1200,
                        component: "comIndex",
                        activeid:params,
                        querytype:'query',
                        showFooter:false,
                    }
                    break;
              
                case 'export':
                    this.handleWebfs(HttpExportUnsourcedInbound, this.formData, { executor: 'request', download: true, });
                    break;
               
               
            }
        },
        getOperateNodeMap(row) {
            const { id } = row;
            return [{
                label: this.$t('global.common.query', { defaultValue: '查看' }),
                show: true,
                params: id,
                operate: 'query'
            }
          ]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusorgList','getCusproductList','getSelfmanageorgList', 'getUserManageWarehouseList']),
        ToolsData() {
            return [
            {
                name: this.$t('global.common.export', { defaultValue: '导出' }),
                operate: "export",
            }]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('fbb.inbound.client_organization', { defaultValue: "客户组织" }),
                    key: 'EQ_organizationId',
                    tag: 'vSelect',
                    options: this.getBillcusorgList,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('', { defaultValue: '入库单号' }),
                    key: 'CN_unsourcedInboundOrderNo',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: this.$t('global.common.warehouse', { defaultValue: '仓库' }),
                    key: 'EQ_orgWarehouseCode',
                    show: true,
                    tag: 'vSelect',
                    options: this.getUserManageWarehouseList,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('', { defaultValue: '来源单号' }),
                    key: 'CN_sourceNo',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: this.$t('fbb.account.cusdisacountrate_source_type', { defaultValue: '来源类型' }),
                    key: 'EQ_orderType',
                    show: true,
                    tag: 'vSelect',
                    options: this.getOrderType,
                },
                {
                    label: this.$t('global.common.line', { defaultValue: '项目' }),
                    key: 'EQ_lineId',
                    tag: 'vSelect',
                    options: this.getCusproductList,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('', { defaultValue: 'Tracking No' }),
                    key: 'CN_trackingNo',
                    tag: 'vInput',
                    more: true,
                },
                {
                    label:'SKU',
                    key: 'sku',
                    show: true,
                    tag: 'vInput'
                },
                {
                    label: this.$t('fbb.transfer.istakepictures', { defaultValue: "是否拍照" }),
                    tag: "vSelect",
                    key: "EQ_hasPicture",
                    options: [
                        {
                            label: this.$t('tms.ship.correct', { defaultValue: "是" }),
                            value: 1
                        },
                        {
                            label: this.$t('tms.ship.deny', { defaultValue: "否" }),
                            value: 0
                        }
                    ],
                },
                {
                    label: this.$t('', { defaultValue: '入库时间' }),
                    tag: 'vDatepicker',
                    key: 'BT_stockinAt',
                    more: true,
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                    },
                }
            ]
        },
        columns() {
            return [
                /* {
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                }, */
                {
                    title: this.$t('global.common.operation', { defaultValue: '操作' }),
                    maxWidth: 90,
                    render: this.getOperateNodes
                },  {
                    title: this.$t('fbb.alloment.client_organization', { defaultValue: '客户' }),
                    key: 'organizationId',
                    render: (h, { row }) => {
                        let orgName = this.getSelfmanageorgList.filter(item => {
                            return item.value === row.organizationId
                        })[0] || {}
                        return orgName.label
                    }
                },{
                    title: this.$t('', { defaultValue: '入库单号' }),
                    render: (h, { row }) => {
                        return <div>
                            <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.unsourcedInboundOrderNo || '--'}</a>
                        </div>
                    }
                }, {
                    title: this.$t('fbb.account.cusdisacountrate_source_type', { defaultValue: '来源类型' }),
                    key: 'orderType',
                    render: (h, {
                        row
                    }) => this.findRenderLabel(this.getOrderType, row.orderType)
                },{
                    title: this.$t('', { defaultValue: '来源单号' }),
                    key: 'sourceNo',
                },{
                    title: this.$t('', { defaultValue: 'Tracking No' }),
                    key: 'trackingNo',
                },{
                    title: this.$t('', { defaultValue: '参考号' }),
                    key: 'refNo',
                },{
                    title: this.$t('global.common.warehouse', { defaultValue: '仓库' }),
                    key: 'orgWarehouseCode',
                },{
                    title: "SKU*数量",
                    key: "skuList",
                    render: (h, { row }) => {
                        // let arrNos = [];
                        if (row.skuList) {
                            return (row.skuList || []).map(item => {
                                let jsonone = item.sku+"*"+item.qty
                                return <div>{jsonone}</div>
                            })
                        } else return '--'
                    }
                }, {
                    title: this.$t('global.common.status', { defaultValue: '状态' }),
                    key: 'unsourcedInboundOrderStatus',
                    render: (h, { row }) => {
                        const status = row.unsourcedInboundOrderStatus;
                        const { theme = 'default', label } = this.getStatus.find(function (item) {
                            return item.value == status
                        }) || {};
                        return <vButton ghost theme={theme} size="small" class="cursor-not width-60">{label}</vButton>
                    }
                },{
                    title: this.$t('', { defaultValue: '接收日期' }),
                    key: 'stockinAt',
                    sortable:true,
                },
                {
                    title: this.$t('global.common.createdtime', { defaultValue: '创建时间' }),
                    key: 'createdAt',
                    sortable:true,
                }];
        },
    },
};




